import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { JobTemplateState } from './type';

const initialState: JobTemplateState = {
  summary: {
    total: 0,
    init: false,
  },
  options: [],
};

export const { actions: jobTemplateActions, reducer: jobTemplateReducer } = createSlice({
  name: 'job-template',
  initialState,
  reducers: {
    updateSummary(state, action: PayloadAction<Omit<JobTemplateState['summary'], 'init'>>) {
      const { payload } = action;

      state.summary = {
        ...payload,
        total: payload.total,
        init: false,
      };
    },
    updateOption(state, action: PayloadAction<JobTemplateState['options']>) {
      const { payload } = action;
      state.options = payload;
    },
  },
});

export * from './type';
export * from './selector';
